import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import styles from './TrustedBy.module.scss';

const clients = [
  { name: 'PARFUMS de MARLY', sub: 'Paris', style: 'serif' },
  { name: 'BVLGARI', style: 'spaced' },
  { name: 'LUA CHEIA', style: 'serif' },
  { name: 'Tiffany & Co.', style: 'serifItalic' },
  { name: 'LA PRAIRIE', sub: 'Switzerland', style: 'spaced' },
  { name: 'CASA PALMA', sub: 'Concept', style: 'serif' },
  { name: 'ZEGNA', style: 'serifBold' },
];

const partners = [
  { name: 'Socialité.', style: 'sansSerif' },
  { name: 'priscilla monteiro', style: 'sansSerif' },
  { name: 'DONLON meets®', style: 'sansSerif' },
];

const countries = ['PANAMÁ', 'COLOMBIA', 'COSTA RICA', 'MÉXICO', 'PERÚ', 'ARGENTINA', 'BRASIL'];

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

const stagger = {
  visible: { transition: { staggerChildren: 0.06, delayChildren: 0.1 } },
};

const TrustedBy = () => {
  const { t } = useTranslation('home');

  return (
    <section className={styles.trustedSection}>
      <div className={styles.container}>
        <motion.div
          className={styles.trustedCard}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={stagger}
        >
          <motion.div className={styles.trustedHeader} variants={fadeUp}>
            <div className={styles.trustedEyebrow}>{t('experience.eyebrow')}</div>
            <h2 className={styles.trustedTitle}>{t('experience.title')}</h2>
            <p className={styles.trustedSubtitle}>{t('experience.subtitle')}</p>
          </motion.div>

          <motion.div className={styles.trustedLogosGrid} variants={stagger}>
            {clients.map((c) => (
              <motion.div key={c.name} className={styles.clientLogoItem} variants={fadeUp}>
                <span className={styles[c.style] || styles.serif}>{c.name}</span>
                {c.sub && <small>{c.sub}</small>}
              </motion.div>
            ))}
          </motion.div>

          <motion.p className={styles.trustedDisclaimer} variants={fadeUp}>
            {t('experience.disclaimer')}
          </motion.p>

          <motion.div className={styles.partnersRow} variants={fadeUp}>
            <span className={styles.partnersTitle}>{t('experience.partners_title')}</span>
            <div className={styles.partnersList}>
              {partners.map((p) => (
                <span key={p.name} className={styles[p.style] || ''}>
                  {p.name}
                </span>
              ))}
            </div>

            <div className={styles.countriesStrip}>
              <span className={styles.countriesLabel}>{t('experience.countries_label')}:</span>
              {countries.map((c) => (
                <span key={c} className={styles.countryItem}>{c}</span>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustedBy;
